/**
 * Shareable Harbour venue URL. One id — Slack paste, not the estate.
 */

import {
  BRIDGE_MINI_TAB_HARBOUR,
  buildBridgeAdminPath,
} from 'src/constants/bridge'

export function buildHarbourVenueShareUrl(venueId, { origin } = {}) {
  const id = String(venueId || '').trim()
  if (!id) {
    return ''
  }

  const path = buildBridgeAdminPath(BRIDGE_MINI_TAB_HARBOUR, { venueId: id })
  const base = String(
    origin || (typeof window !== 'undefined' && window.location?.origin) || '',
  ).replace(/\/$/, '')

  return `${base}${path}`
}
